<template>
    <section class="consult-sec">
        <img v-if="width > 1024" src="../assets/images/section-bg-2.png" alt="" class="consult-sec-bg">
        <div class="consult-sec-container">
            <div class="consult-sec-img">
                <img src="../assets/images/Rectangle 15 (4).png">
            </div>
            <div class="consult-sec-txt">
                <h2>تبلیغات در فیلو؛ <br>
                    یکی از بزرگترین پلتفرم های اشتراک ویدیو در کشور
                </h2>
                <p>فیلو، با میلیون ها کاربر و محتوای متنوع، بهترین مکان برای نمایش تبلیغات شماست. با فیلو، تبلیغاتتان را
                    مستقیماً به مخاطبان هدف خود نمایش دهید و برندتان را در ذهن آن ها ماندگار کنید.
                </p>
                <div class="consult-sec-btn">
                    <!-- <a href="" class="btn btn--info">اطلاعات بیشتر</a> -->
                    <button class="btn btn--consult" @click.stop="openModal">مشاوره رایگان</button>
                </div>
            </div>
            <ModalBox :isModalOpen="showModal" @close="closeModal"></ModalBox>
        </div>
    </section>
</template>

<script>
import ModalBox from './ModalBox.vue';
import { useModal } from '@/useModal';
import { inject } from "vue";
export default {
    name: "ConsultSection",
    components: {
        ModalBox,
    },
    setup() {
        const width = inject('viewportWidth');

        const { showModal, openModal, closeModal } = useModal();


        return {
            width,
            showModal,
            openModal,
            closeModal,
        };
    },

};
</script>

<style scoped>
.consult-sec {
    position: relative;
}

.consult-sec,
.consult-sec-container {
    display: grid;
}

.consult-sec,
.consult-sec-bg {
    width: 100%;
}

.consult-sec,
.consult-sec-container,
.consult-sec-img {
    align-items: center;
}

.consult-sec-bg {
    max-height: 635px;
    margin-block: 42.5px;
}

.consult-sec-bg,
.consult-sec-container {
    grid-area: 1 / 1;
}

.consult-sec-container {
    padding-inline: 12.58%;
    grid-template-columns: 36.89% 52.822%;
    gap: 10.37%;
}

.consult-sec-img {
    background-color: var(--glass-morphism);
    box-shadow: 0 2px 10px var(--shadow-light);
    aspect-ratio: 530 / 600;
    max-height: 600px;
    padding-inline: 7.452%;
    justify-content: center;
}

.consult-sec-img,
.consult-sec-txt {
    backdrop-filter: blur(20px);
    border-radius: 20px;
}

.consult-sec-img,
.consult-sec-btn {
    display: flex;
}


.consult-sec-img img {
    aspect-ratio: 451 / 520;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
}

.consult-sec-txt {
    align-self: center;
    padding: 9.1% 6.917%;
    box-shadow: 0 0 10px var(--shadow-light);
}

.consult-sec-txt h2 {
    font-size: 28px;
    line-height: 38px;
    font-family: IRANYekan-Bold;
}

.consult-sec-txt p {
    margin-top: 5.82%;
    text-align: justify;
    line-height: 28px;
}

.consult-sec-btn {
    margin-top: 5.51%;
    gap: 4.44%;
}

@media screen and (min-width: 1921px) {
    .consult-sec-container {
        width: 1437px;
        margin-inline: auto;
        padding-inline: 0;
    }
}

@media screen and (max-width: 1230px) {
    .consult-sec-container {
        padding-inline: 11.08%;
    }
}

@media screen and (max-width: 1024px) {
    .consult-sec {
        margin-inline: 5.556%;
        width: calc(100% - 11.112%);
    }

    .consult-sec-container {
        padding: 40px 4.75%;
        background-color: var(--glass-morphism);
        box-shadow: 0 0 2px var(--shadow-light);
        border-radius: 20px;
    }

    .consult-sec-img {
        box-shadow: none;
        aspect-ratio: unset;
    }

    .consult-sec-txt {
        box-shadow: none;
        backdrop-filter: none;
        padding: 0;
    }

    .consult-sec-txt h2 {
        font-size: 24px;
        line-height: 28px;
    }

    .consult-sec-txt p {
        line-height: 26px;
    }
}

@media screen and (max-width: 768px) {
    .consult-sec-container {
        grid-template-columns: 100%;
        justify-items: center;
        gap: 23px;
        padding: 18px 3.75% 21px;
        margin-top: 67px;
    }

    .consult-sec-img {
        aspect-ratio: 211 / 248;
        box-shadow: 0 2px 10px var(--shadow-light);
        max-height: 248px;
        padding-inline: 16px;
        background-color: #ffffff;
        margin-top: -44px;
    }

    .consult-sec-img img {
        aspect-ratio: 179 / 207;
        max-height: 207px;
    }

    .consult-sec-txt p,
    .consult-sec-btn {
        margin-top: 12px;
    }

    .consult-sec-btn {
        justify-content: center;
    }

}

@media screen and (max-width: 375px) {
    .consult-sec-txt h2 {
        font-size: 20px;
    }

    .consult-sec-txt p {
        font-size: 16px;
    }
}
</style>